import createBootstrapLoader from 'actions/bootstrap/createBootstrapLoader'
import { createFetchAgentsLoader } from 'actions/agents/createFetchAgents'
import { createFetchFoldersLoader } from 'ducks/folders/operations/folders'
import { createFetchGroupsLoader } from 'actions/groups/createFetchGroups'
import createFetchAccountLoader from 'actions/account/createFetchAccountLoader'
import { createFetchWidgetsLoader } from 'ducks/widgets/operations/createFetchWidgets'
import { createFetchCurrentUserLoader } from 'ducks/currentUser/operations/createFetchCurrentUser'
import { createFetchBillingLoader } from 'ducks/billing/operations/createFetchBillingLoader'

const BOOTSTRAP_LOADERS = [
  createFetchAgentsLoader(),
  createFetchGroupsLoader(),
  createFetchAccountLoader(),
  createFetchWidgetsLoader(),
  createFetchFoldersLoader(),
  createFetchCurrentUserLoader(),
  createFetchBillingLoader(),
]

export const doChatBootstrap = createBootstrapLoader(BOOTSTRAP_LOADERS)
